"use client";

import { useEffect, useState } from "react";
import { InboxIcon as EnvelopeIcon, PhoneIcon } from "lucide-react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ShowMembers() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
  //   const [formData, setFormData] = useState({
  //     firstName: "Brahim",
  //     lastName: "JAOUANE",
  //     email: "benzakour@gmail.com",
  //     phoneNumber: "+212640404040",
  //     country: "Morocco",
  //     city: "Casablanca",
  //     dateOfBirth: "26/06/1991",
  //     industry: "Ingénieur",
  //   });

  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [country, setCountry] = useState(null);
  const [city, setCity] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [sector, setSector] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [user, setUser] = useState();
  const [picture, setPicture] = useState(null);
  const [isLoadingMembers, setIsLoadingMembers] = useState(true);

  const location = useLocation();
  const { userId } = location?.state; // Ensure `pack` and `id` are safely accessed

  useEffect(() => {
    const fetchUser = async () => {
      setIsLoadingMembers(true);
      const token = localStorage.getItem("userToken");

      try {
        if (token) {
          const response = await axios.get(`${baseUrl}/members/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setData(response);
          //setting the states from the response
          setLname(response.data.member.nom);
          setFname(response.data.member.prenom);
          setEmail(response.data.member.email);
          setPhoneNumber(response.data.member.telephone);
          setCity(response.data.member.ville);
          setCountry(response.data.member.pays);
          setDateOfBirth(response.data.member.date_naissance);
          setPicture(response.data.member.photo);

          setSector(response.data.member["secteur_d'activite"]);
          setUser(response.data.member);

          //   if (response.data.membership) {
          //     setIsEnabled(response.data.membership?.visibility || false);
          //     if (response.data?.membership?.status.trim() === "valid") {
          //       setPack(response.data.membership?.membership_packs);
          //     }
          //   }

          const [day, month, year] = response.data.date_naissance.split("/");
          const birthDate = new Date(year, month - 1, day);


          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          // Check if the birthday has occurred this year
          const monthDiff = today.getMonth() - birthDate.getMonth();
          const dayDiff = today.getDate() - birthDate.getDate();

          if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--; // Reduce age if the birthday hasn't passed yet this year
          }

          //   if (age < 25) {
          //     setDateOfBirthMessage(
          //       "Users under 25 years old cannot complete registration."
          //     );
          //     setDateValidated(false);
          //   } else {
          //     setDateValidated(true);

          //     setDateOfBirthMessage(null);
          //   }
        }
      } catch (error) {

      } finally {
        setIsLoadingMembers(false);
      }
    };

    fetchUser();

    // return () => {
    //   setUser(null);
    //   setUploadErr(null);
    // };
  }, []);
  //   console.log("oooooooooo", isLoadingMembers,email);

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    
          <div className="bg-white bg-opacity-[87%] h-full flex flex-col justify-center  items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-16">
            {isLoadingMembers ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
              </div>
            ) : (
              <div className="w-full flex flex-col gap-5 justify-center  items-center">
                <div className="flex flex-col w-full items-center">
                  {/* Profile image with orange background and ribbon */}
                  <img
                    src={picture}
                    alt=""
                    width={180}
                    className="rounded-full"
                  />
                </div>

                {/* Form fields */}
                <div className="space-y-4 w-[60%]">
                  <div>
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr" ? "Prénom" : "First Name"}
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      value={fname}
                      readOnly
                      className="mt-1 block w-full px-4 py-3 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="lastName"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr" ? "Nom" : "Family Name"}
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      value={lname}
                      readOnly
                      className="mt-1 block w-full px-4 py-3 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700"
                    >
                      E-mail
                    </label>
                    <div className="mt-1 flex rounded-full overflow-hidden border border-gray-300">
                      <input
                        type="email"
                        id="email"
                        value={email}
                        readOnly
                        className="block w-full px-4 py-3 bg-white focus:outline-none"
                      />
                      <button
                        onClick={handleEmailClick}
                        className="bg-green-500 text-white px-4 flex items-center justify-center"
                      >
                        <EnvelopeIcon className="h-5 w-5" />
                      </button>
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="phoneNumber"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr"
                        ? "Numéro de téléphone"
                        : "Phone Number"}
                    </label>
                    <div className="mt-1 flex rounded-full overflow-hidden border border-gray-300">
                      <input
                        type="tel"
                        id="phoneNumber"
                        value={phoneNumber}
                        readOnly
                        className="block w-full px-4 py-3 bg-white focus:outline-none"
                      />
                      <button
                        onClick={handlePhoneClick}
                        className="bg-green-500 text-white px-4 flex items-center justify-center"
                      >
                        <PhoneIcon className="h-5 w-5" />
                      </button>
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="country"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr" ? "Pays" : "Country"}
                    </label>
                    <input
                      type="text"
                      id="country"
                      value={country}
                      readOnly
                      className="mt-1 block w-full px-4 py-3 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="city"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr" ? "Ville" : "City"}
                    </label>
                    <input
                      type="text"
                      id="city"
                      value={city}
                      readOnly
                      className="mt-1 block w-full px-4 py-3 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="dateOfBirth"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr" ? "Date de naissance" : "Date of Birth"}
                    </label>
                    <input
                      type="text"
                      id="dateOfBirth"
                      value={dateOfBirth}
                      readOnly
                      className="mt-1 block w-full px-4 py-3 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="industry"
                      className="block text-sm font-medium text-gray-700"
                    >
                      {language === "fr" ? "Industrie" : "Industry"}
                      
                    </label>
                    <input
                      type="text"
                      id="industry"
                      value={sector}
                      readOnly
                      className="mt-1 block w-full px-4 py-3 bg-white border border-gray-300 rounded-full shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
       
  );
}
